import { LinePanel } from '../components/LinePanel';
import { Banner, Panel } from '../components/Panel';
import { PushPanel } from '../components/PushPanel';
import { AlertControls } from '../components/SignalPanel';
import { useSettings } from '../hooks/queries';
import { humanize } from '../lib/format';

function KV({ data }: { data: Record<string, unknown> }) {
  return (
    <dl className="kv">
      {Object.entries(data).map(([k, v]) => (
        <div key={k} style={{ display: 'contents' }}>
          <dt>{humanize(k.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase())}</dt>
          <dd className="num">
            {v === null || v === undefined ? '—' : typeof v === 'object' ? JSON.stringify(v) : String(v)}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export function SettingsPage() {
  const { data, isLoading, isError } = useSettings();
  return (
    <>
      <div className="page__header">
        <h1>Settings</h1>
        <p className="page__lede">
          Notifications for both alert systems, then the read-only market-data and news configuration (backend
          environment variables).
        </p>
      </div>
      <Panel title="การแจ้งเตือน (ใช้ร่วมกันทั้งสองระบบ)">
        <p className="small muted" style={{ marginTop: 0 }}>
          ใช้กับทั้งสัญญาณ Stochastic และสัญญาณแนวรับแนวต้าน · ระบบแนวรับแนวต้านส่งทางแอป/LINE
          เมื่อผู้ดูแลเปิดสวิตช์ของระบบนั้นแล้วเท่านั้น
        </p>
        <h3 className="section-title">เบราว์เซอร์นี้</h3>
        <AlertControls />
        <p className="small muted">แจ้งเตือนในเบราว์เซอร์ทำงานเมื่อเปิดแท็บ MagicTradie! ไว้ (อยู่เบื้องหลังได้)</p>
        <h3 className="section-title">แอปบนมือถือ / คอมพิวเตอร์เครื่องนี้</h3>
        <PushPanel />
        <h3 className="section-title">LINE</h3>
        <LinePanel />
      </Panel>
      <div style={{ marginTop: 16 }}>
        <Banner tone="info" title="View only">
          Alerts only: this build has no trading or order execution of any kind.
        </Banner>
      </div>
      {isLoading ? <p className="muted">Loading configuration…</p> : null}
      {isError ? <p className="muted">Configuration unavailable.</p> : null}
      {data ? (
        <div className="grid grid--2">
          <Panel title="Market data">
            <KV data={data.market} />
          </Panel>
          <Panel title="News">
            <KV data={data.news} />
          </Panel>
        </div>
      ) : null}
    </>
  );
}
